var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.permissions('accessReports'))?_c('v-container'):_c('denied-access')}
var staticRenderFns = []

export { render, staticRenderFns }